import React from 'react';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import { LocalizationContext } from '../../../hoc/Localization';
import { UserContext } from '../../../hoc/User';
import StepContainer from '../StepContainer';

import SelectType from './SelectType';
import { trainingTypeOptions } from '../../../config/trainingTypeOptions';

const TypeSelection = () => {
  const { t, translate, locale } = React.useContext(LocalizationContext);
  const { edited, updateContent } = React.useContext(EditorWizardContext);
  const { user } = React.useContext(UserContext);

  if (process.browser) {
    React.useEffect(() => {
      if (window.fbq && !user) {
        window.fbq('trackCustom', 'WizardLoginShown');
      }
    }, [window.fbq]);
  }

  const setValue = (data, key) => {
    updateContent(key, data);
  };

  const images = [
    '/static/images/wizard/course.svg',
    '/static/images/wizard/webinar.svg',
    '/static/images/wizard/eLearning.svg',
  ];

  return (
    <StepContainer nextButtonDisabled={!edited.trainingType}>
      <SelectType
        user={user}
        locale={locale}
        setValue={setValue}
        t={t}
        translate={translate}
        trainingTypeOptions={trainingTypeOptions}
        images={images}
        selected={edited.trainingType}
      />
    </StepContainer>
  );
};

export default TypeSelection;
